import { type TFunction } from 'i18next';
import { z } from 'zod';

import { HcoSchema } from '@/core/graphql/generated/validation.zod';
import { MultiPrimaryItemSchema } from '@/features/DataChangeRequest/_schemas/MultiPrimaryItemSchema.validation';

export const OrganizationalSectionSchema = (t?: TFunction) => {
	const raw = HcoSchema().pick({
		hcoType: true,
		statusCda_V: true,
		nhidCda_V: true
	});

	const requiredMsg = t
		? t('This field is required')
		: 'This field is required';

	return z
		.object({
			hcoType: z.string().min(1, { message: requiredMsg }),
			hcoTypeLocal_VId: z.string().nullish(),
			typeOfHierarchy_VId: z.string().nullish(),
			countHcp_VId: z.string().nullish(),
			countPrescriber_VId: z.string().nullish(),

			// derived array for form, not part of backend schema
			allSpecLocal_VId: z.array(MultiPrimaryItemSchema).max(2).default([]),

			statusCda_V: raw.shape.statusCda_V
				.pipe(z.string().catch(''))
				.transform(s => s.trim()),

			businessType_V: z.string().nullish(),
			hcoOwnership_VId: z.string().nullish(),
			academicStatus_VId: z.string().nullish(),

			nhidCda_V: z.string().nullish(),

			hcoTaxId_V: z.string().nullish()
			// vaDodAffiliated_V: z.boolean().catch(false)
		})
		.strict();
};

export type OrganizationalSectionValuesIn = z.input<
	ReturnType<typeof OrganizationalSectionSchema>
>;
export type OrganizationalSectionValuesOut = z.output<
	ReturnType<typeof OrganizationalSectionSchema>
>;
